import { useState } from 'react';

import type { ExtensionReportFieldVisibility } from '../../exportExtensionReport/types';

export type ExtensionCheckboxesState = ExtensionReportFieldVisibility;

export type ExtensionCheckboxesSetters = {
  setShowDocumentInfo: (value: boolean) => void;
  setShowExtensionInfo: (value: boolean) => void;
  setShowDates: (value: boolean) => void;
  setShowParamsAndCosts: (value: boolean) => void;
  setShowObservation: (value: boolean) => void;
  setShowDocumentFinancials: (value: boolean) => void;
  setShowPendingAccounts: (value: boolean) => void;
};

const defaultVisibility: Required<ExtensionReportFieldVisibility> = {
  showDocumentInfo: true,
  showExtensionInfo: true,
  showDates: true,
  showParamsAndCosts: true,
  showObservation: true,
  showDocumentFinancials: true,
  showPendingAccounts: true,
};

export const useExtensionCheckboxes = (): [
  ExtensionCheckboxesState,
  ExtensionCheckboxesSetters,
] => {
  const [showDocumentInfo, setShowDocumentInfo] = useState(
    defaultVisibility.showDocumentInfo,
  );
  const [showExtensionInfo, setShowExtensionInfo] = useState(
    defaultVisibility.showExtensionInfo,
  );
  const [showDates, setShowDates] = useState(defaultVisibility.showDates);
  const [showParamsAndCosts, setShowParamsAndCosts] = useState(
    defaultVisibility.showParamsAndCosts,
  );
  const [showObservation, setShowObservation] = useState(
    defaultVisibility.showObservation,
  );
  const [showDocumentFinancials, setShowDocumentFinancials] = useState(
    defaultVisibility.showDocumentFinancials,
  );
  const [showPendingAccounts, setShowPendingAccounts] = useState(
    defaultVisibility.showPendingAccounts,
  );

  const state: ExtensionCheckboxesState = {
    showDocumentInfo,
    showExtensionInfo,
    showDates,
    showParamsAndCosts,
    showObservation,
    showDocumentFinancials,
    showPendingAccounts,
  };

  const setters: ExtensionCheckboxesSetters = {
    setShowDocumentInfo,
    setShowExtensionInfo,
    setShowDates,
    setShowParamsAndCosts,
    setShowObservation,
    setShowDocumentFinancials,
    setShowPendingAccounts,
  };

  return [state, setters];
};
